// extracted by mini-css-extract-plugin
export default {"check":"order-confirm_check__dg9-o","text":"order-confirm_text__u4Dbu"};